// extracted by mini-css-extract-plugin
export var errorIcon = "_lo-1";
export var nameLogo = "_lo-0";